import Login from "../core/components/login/login";
import Dashboard from "./Dashboard/dashboard";
import Trading from "./Trading/trading";
import MomentumTrading from "./MomentumTrading/momentumTrading";
import SaleEngine from "./SaleEngine/saleEngine";
import LivePrediction from "./LivePrediction/livePrediction";
import BackTesting from "./BackTesting/backtesting";
import ConfigureTrend from "./ConfigureTrend/configureTrend";
import ManagePaperTrade from "./ManagePaperTrade/managePaperTrade";
import SystemError from "./SystemError/systemError";
import Screening from "./Screening/screening";

export const IPages = {
  Login,
  Dashboard,
  Trading,
  MomentumTrading,
  SaleEngine,
  LivePrediction,
  BackTesting,
  ConfigureTrend,
  ManagePaperTrade,
  SystemError,
  Screening,
};
